export enum LabelPosition {
	Top,
	Left,
	Right
}